import { useToken } from "@gluestack-style/react";
import { Box, Divider, FormattedDate, H1, H2, HStack, Text } from "components/ui";
import { Wrench } from "lucide-react-native";
import React from "react";
import { Col, Row } from "react-native-flex-grid";
import { ServiceOrder } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import ServiceOrderTechnicianTripTable from "./ServiceOrderTechnicianTripTable";
import ScrollContainer from "components/general/ScrollContainer";
import Container from "components/general/Container";
import Breadcrumbs from "components/general/Breadcrumbs";
import PageHeader from "components/general/Headers/PageHeader";
import Section from "components/general/Section";

interface Props {
	data: ServiceOrder;
}

export function ServiceOrderDetail({ data: serviceOrder }: Props) {
	const isMobile = useIsMobile();
	const resolvedPrimarylight = useToken("colors", "primarylightblue");

	const labelHeader = { fontWeight: "bold", fontFamily: "inter" };
	const labelText = { fontSize: 16, fontFamily: "inter" };
	const rowStyle = { marginTop: 6, marginBottom: 6, padding: 2 };
	const columnStyle = { maxWidth: 300 };
	const boxWrapper = { marginTop: 10, marginBottom: 10, paddingVertical: 10, paddingHorizontal: 10, bg: "$neutral25" };

	return (
		<Box>
			<PageHeader
				title={
					<HStack gap={12} alignItems="center">
						<Wrench size={isMobile ? 20 : 36} color={resolvedPrimarylight} />
						<H1>{serviceOrder.caseNumber}</H1>
					</HStack>
				}
				idReplacement={serviceOrder.caseNumber}
			/>
			<Container>
				<Box gap={24}>
					<Section marginTop={isMobile ? 24 : 0}>
						<Box flex={1} flexDirection="column">
							<Row style={rowStyle}>
								<Col style={columnStyle}>
									<Text sx={labelHeader}>Case Number:</Text>
								</Col>
								<Col>
									<HStack gap={8}>
										<Text fontSize={16} fontFamily="inter">
											{serviceOrder.caseNumber}
										</Text>
									</HStack>
								</Col>
							</Row>
							<Row style={rowStyle}>
								<Col style={columnStyle}>
									<Text sx={labelHeader}>Service Type:</Text>
								</Col>
								<Col>
									<Text sx={labelText}>{serviceOrder.serviceType}</Text>
								</Col>
							</Row>
							<Row style={rowStyle}>
								<Col style={columnStyle}>
									<Text sx={labelHeader}>Problem Description:</Text>
								</Col>
								<Col>
									<Text sx={labelText}>{serviceOrder.problemDescription}</Text>
								</Col>
							</Row>
							<Row style={rowStyle}>
								<Col style={columnStyle}>
									<Text sx={labelHeader}>Workflow Status:</Text>
								</Col>
								<Col>
									<Text sx={labelText}>{serviceOrder.workflowStatus}</Text>
								</Col>
							</Row>
							<Row style={rowStyle}>
								<Col style={columnStyle}>
									<Text sx={labelHeader}>Start Date:</Text>
								</Col>
								<Col>
									<FormattedDate variant="DD/MM/YYYY" date={serviceOrder.startDate} />
								</Col>
							</Row>
							<Row style={rowStyle}>
								<Col style={columnStyle}>
									<Text sx={labelHeader}>Due Date:</Text>
								</Col>
								<Col>
									<FormattedDate variant="DD/MM/YYYY" date={serviceOrder.dueDate} />
								</Col>
							</Row>
						</Box>
					</Section>
					<Section>
						<H2 sx={{ marginBottom: 20 }}> Technician Trips </H2>
						<ServiceOrderTechnicianTripTable dataList={serviceOrder.technicianTripCollection} />
					</Section>
				</Box>
			</Container>
		</Box>
	);
	// return (<Box
	// 	flex={1}
	// 	width="100%"
	// 	sx={{
	// 		marginTop: 20,
	// 		marginBottom: 20,
	// 	}}>
	// 		<>
	// 			<Box flexDirection={isMobile ? "column" : "row"}  mb={12} sx={{ marginTop: 10, marginBottom: 10, paddingVertical: 10}}>
	// 				<Box flex={2}>
	// 					<HStack gap={12} alignItems="flex-start">
	// <H1><Wrench size={isMobile ? 20 : 36} color={resolvedPrimarylight} /> {serviceOrder.caseNumber}</H1>
	// 					</HStack>
	// 				</Box>
	// 				<Box flex={1} flexDirection="row" justifyContent={isMobile ? "flex-start" : "flex-end"}>
	// 					<HStack gap={4} alignItems={isMobile ? "flex-start" : "flex-end"}>
	// 						<Text></Text>
	// 					</HStack>
	// 				</Box>
	// 			</Box>

	// 			{isMobile && (
	// 			<Box flex={1} flexDirection="column">
	// 				<Row style={rowStyle}>
	// 					<Col>
	// 						<Text sx={labelText}>{serviceOrder.serviceType}</Text>
	// 					</Col>
	// 					<Col>
	// 						<Text sx={labelText}>{serviceOrder.workflowStatus}</Text>
	// 					</Col>
	// 				</Row>
	// 				<Row style={rowStyle}>
	// 					<Col>
	// 						<Text>Start Date</Text><FormattedDate sx={{ color: "$neutral400", fontSize: 14 }} variant="DD/MMM" date={serviceOrder.startDate} />
	// 					</Col>
	// 					<Col>
	// 						<Text>Due Date</Text><FormattedDate sx={{ color: "$neutral400", fontSize: 14 }} variant="DD/MMM" date={serviceOrder.dueDate} />
	// 					</Col>
	// 				</Row>
	// 				<Row style={rowStyle}>
	// 					<Col>
	// 						<Text mb={10}>Problem Description</Text>
	// 						<Text bg="$neutral25" padding={10} sx={labelText}>{serviceOrder.problemDescription}</Text>
	// 					</Col>
	// 				</Row>
	// 			</Box>
	// 			)}

	// 			{!isMobile && (
	// 			<Box flex={1} flexDirection="column">
	// 				<Row style={rowStyle}>
	// 					<Col style={columnStyle}>
	// 						<Text sx={labelHeader}>Case Number</Text>
	// 					</Col>
	// 					<Col>
	// 						<HStack gap={8}>
	// 							<Text fontSize={16}>{serviceOrder.caseNumber}</Text>
	// 						</HStack>
	// 					</Col>
	// 				</Row>
	// 				<Row style={rowStyle}>
	// 					<Col style={columnStyle}>
	// 						<Text sx={labelHeader}>Service Type</Text>
	// 					</Col>
	// 					<Col>
	// 						<Text sx={labelText}>{serviceOrder.serviceType}</Text>
	// 					</Col>
	// 				</Row>
	// 				<Row style={rowStyle}>
	// 					<Col style={columnStyle}>
	// 						<Text sx={labelHeader}>Problem Description</Text>
	// 					</Col>
	// 					<Col>
	// 						<Text sx={labelText}>{serviceOrder.problemDescription}</Text>
	// 					</Col>
	// 				</Row>
	// 				<Row style={rowStyle}>
	// 					<Col style={columnStyle}>
	// 						<Text sx={labelHeader}>Workflow Status</Text>
	// 					</Col>
	// 					<Col>
	// 						<Text sx={labelText}>{serviceOrder.workflowStatus}</Text>
	// 					</Col>
	// 				</Row>
	// 				<Row style={rowStyle}>
	// 					<Col style={columnStyle}>
	// 						<Text sx={labelHeader}>Start Date</Text>
	// 					</Col>
	// 					<Col>
	// 						<FormattedDate variant="DD/MM/YYYY" date={serviceOrder.startDate} />
	// 					</Col>
	// 				</Row>
	// 				<Row style={rowStyle}>
	// 					<Col style={columnStyle}>
	// 						<Text sx={labelHeader}>Due Date</Text>
	// 					</Col>
	// 					<Col>
	// 						<FormattedDate variant="DD/MM/YYYY" date={serviceOrder.dueDate} />
	// 					</Col>
	// 				</Row>
	// 			</Box>
	// 			)}
	// 		</>

	// 		<Box sx={{...boxWrapper}} bg="$neutral25">
	// 			<H2 sx={{marginBottom: 20}}> Technician Trips </H2>
	// 			<ServiceOrderTechnicianTripTable dataList={serviceOrder.technicianTripCollection} />
	// 		</Box>

	// </Box>);
}
